import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getProviderRateReview = createAsyncThunk("provdier/get-rate-review", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/get-rate-review`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers review");
  }
});

const providerRateReviewSlice = createSlice({
  name: "providerRateReview",
    initialState: {
      providerRateReview: null,
      providerList: [],
      loading: false,
      error: null,
      message: "",
      
    },
    extraReducers: (builder) => {
      builder
        .addCase(getProviderRateReview.pending, (state) => {
            state.loading = true;
        })
        .addCase(getProviderRateReview.fulfilled, (state, action) => {
            state.providerRateReview = action.payload.clientReview;
            state.loading = false;
        })
        .addCase(getProviderRateReview.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch providers review"; 
            state.loading = false;
        })
    },
});

export default providerRateReviewSlice.reducer;